import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 发送方查看委托历史
export function queryHistoryFromSender(params) {
  return request({
    url: URL.seaExport.queryHistoryFromSender,
    method: 'get',
    params
  })
}

// 查询发送方最新的委托状态
export function queryLatestState(params) {
  return request({
    url: URL.seaExport.queryLatestState,
    method: 'get',
    params
  })
}

// 接收方查看委托历史
export function queryHistoryFromReceiver(params) {
  return request({
    url: URL.seaExport.queryHistoryFromReceiver,
    method: 'get',
    params
  })
}

// 查询接收方最新的委托状态
export function queryLatestStateFromReceiver(params) {
  return request({
    url: URL.seaExport.queryLatestStateFromReceiver,
    method: 'get',
    params
  })
}
